import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  caseStudyList: [],
};

export const relatedCaseExamplesSlice = createSlice({
  name: "relatedCaseExamples",
  initialState,
  reducers: {
    relatedCaseExamplesStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    relatedCaseExamplesSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      caseStudyList: action.payload,
    }),
    relatedCaseExamplesFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    resetRelatedCaseExamples: () => ({
      ...initialState,
    })
  },
});

export const { 
  relatedCaseExamplesStart,
  relatedCaseExamplesSuccess,
  relatedCaseExamplesFailure,
  resetRelatedCaseExamples,
} = relatedCaseExamplesSlice.actions;

export const getRelatedCaseExamples= (id) => (dispatch) => {
  dispatch(relatedCaseExamplesStart());
  const apiPath = `${Constants.API.CASE_EXAMPLES}/${id}${Constants.API.RELATED}`;
  apiService.get(apiPath).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(relatedCaseExamplesSuccess(data?.data));
      } else {
        dispatch(relatedCaseExamplesFailure());
      }
    } else {
      dispatch(relatedCaseExamplesFailure());
    }
  }).catch(() => {
    dispatch(relatedCaseExamplesFailure());
  })
};

export default relatedCaseExamplesSlice.reducer;
